import svg from './row-svg/conversation-notif.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ConversationNotifIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default ConversationNotifIcon;
